import { Directive, ElementRef, Input } from '@angular/core';
import { SnippetDirectiveType } from './types';

@Directive({
  selector: '[snippet]',
  standalone: true,
})
export class SnippetDirective implements SnippetDirectiveType {
  @Input() snippet = ''; // name of the sub selector for the snippet, e.g. 'menuHeader' or 'menuFooter'

  // eslint-disable-next-line no-useless-constructor
  constructor(public elementRef: ElementRef<HTMLElement>) {}

  getSnippetSelector(): string {
    return this.snippet;
  }

  getHtmlContent(): string {
    this.showElement();
    return this.elementRef.nativeElement.outerHTML;
  }

  hideElement(): void {
    this.elementRef.nativeElement.style.display = 'none';
  }

  private showElement(): void {
    this.elementRef.nativeElement.style.display = '';
  }
}
